import { FC } from 'react';
import classnames from 'classnames';
import { TabsProps } from './tabsTypes';
import styles from './tabs.module.scss';

const Tabs: FC<TabsProps> = (props: TabsProps) => {
    const { title, tabs, currentTabId, onTabClick } = props;
    return (
        <div className={styles.wrapper}>
            {title && <div className={styles.title}>{title}</div>}
            {title && <div className={styles.divider} />}
            {tabs.map(tab => {
                const { id, title, count, isNotClickable } = tab;
                const isTabSelected = id === currentTabId;
                const tabTitle = `${title}${count !== undefined ? ` (${count})` : ''}`;
                return (
                    <div key={id} onClick={() => (isNotClickable ? undefined : onTabClick(id))} className={styles.tab}>
                        <div
                            className={classnames({
                                [styles['selected-title']]: isTabSelected,
                                [styles['disabled-tab']]: !isTabSelected,
                                [styles['default-cursor']]: isNotClickable
                            })}
                        >
                            {tabTitle}
                        </div>
                        <div
                            className={classnames(styles.underline, { [styles['selected-underline']]: isTabSelected })}
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default Tabs;
